/* istanbul ignore file */
// This file is tested by e2e ignore it on jest.
import 'core-js/modules/es.array.iterator'; // required for IE11 compatibility
import 'core-js/features/array'; // required for IE11 compatibility
import 'core-js/features/object'; // required for IE11 compatibility
import 'react-app-polyfill/ie11'; // required for IE11 compatibility
import { App } from 'modules';
import React from 'react';
import ReactDom from 'react-dom';
import { isProduction, getPortalVariables } from './utils';

import '@core/toolkit/index.module.scss';
import './styles/base.scss'; // Injects global base style for demo env.

if (!isProduction()) {
  // eslint-disable-next-line no-unused-expressions
  import('./dev.scss');
}

if (isProduction() && getPortalVariables('CDN_URL')) {
  // eslint-disable-next-line
  __webpack_public_path__ = getPortalVariables('CDN_URL');
}
const rootElement = document.getElementById('manomano-portal');

if (rootElement) {
  ReactDom.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement,
  );
}
